import React, { useEffect} from "react";
import Menu from 'components/main/Menu';
import Overlay from 'components/main/Overlay';
import LoadingOverlay from 'components/main/LoadingOverlay';
import TabsContainer from 'components/main/TabsContainer';
import Tooltip from 'components/main/Tooltip';
import About from 'components/main/About';

import { fetchAreas, fetchArea } from 'js/fetchers'
import { useDispatch, useSelector } from 'react-redux';

export default function App(props) {
  const dispatch = useDispatch();
  const loading = useSelector((state) => state.loading);
  const about = useSelector((state) => state.about);

  useEffect(() => { 
    var callback2 = ([features,data]) => {
      dispatch({ type: 'SET_ZONE', payload: {zone:'global', allData: data, features: features.features}})
      dispatch({ type: 'SET_DATASET', payload: 'sst-insitu'})

      setTimeout(() => {dispatch({ type: 'SET_LOADING', payload: 0})}, 250);
    }
    var callback = (data) => {
      data = data.reduce((obj, item) => ({...obj, [item['name']]: item }), {})
      //var dataFilterTmp = {'global': data['global'], 'ibi': data['ibi'], 'medsea': data['medsea']}
      dispatch({ type: 'SET_ZONES', payload: data});
      fetchArea('global', data['global'].id, callback2)
    }
    fetchAreas(callback)
  }, []);

  if (loading)
    return (
      <div style={{height: "100%"}}>
        <LoadingOverlay />
      </div>
    );

  return (
    <div style={{height: "100%"}}>
      <div className="table" id="mainL">
          {about && <About/>}
          <Menu/>
          <TabsContainer />
      </div>
      <Overlay />
      <Tooltip />
    </div>
  );
}
